<template>
<ReconciliationDetailVue :SpecialGetDetail="getDetail" ref="SuitReconciliationDetail">
  <template #MTOColumnSlot>
    <el-table-column v-if="isApCheckReqBill" :width="WidthControl('MTONo',$refs.SuitReconciliationDetail.tableData)"  prop="MTONo" :label="$t('speOrder.mtoNo')"></el-table-column>
    <el-table-column v-if="isApCheckReqBill" :width="WidthControl('BatchNo',$refs.SuitReconciliationDetail.tableData)" prop="BatchNo" :label="$t('speOrder.batchNo')"></el-table-column>
  </template>
</ReconciliationDetailVue>
</template>
<script>
import ReconciliationDetailVue from '@/view/ReconciliationDetail.vue';
export default {
  data(){
    return{
      isApCheckReqBill:false
    }
  },
  components: { 
    ReconciliationDetailVue
  },
  methods:{
    getDetail(that) {
      that.tableLoading = true;
      that.axiosInvoke(
        "/SupplierComm/Handler/ZLOrderHandler.ashx", {
        action: 'getreconciliationdetail',
        billno: that.billNo
      }, (res) => {
        var data = eval(res.data);
        this.$refs.SuitReconciliationDetail.setHeadTable(that,data);
        this.isApCheckReqBill = data[0].IsApCheckReqBill;
        data.shift(0);
        that.tableData = data;
        that.tableLoading = false;
        console.log(data);// 附件类型（供应商平台配置）
        that.getbillaccessorylist();
      }
      );
    }
  }
}
</script>
<style scoped>

</style>
